import { render, staticRenderFns } from "./tags.html?vue&type=template&id=ca782076&scoped=true&"
import script from "./tags.js?vue&type=script&lang=js&"
export * from "./tags.js?vue&type=script&lang=js&"
import style0 from "./tags.scss?vue&type=style&index=0&id=ca782076&prod&scoped=true&lang=scss&"
import style1 from "./index.vue?vue&type=style&index=1&id=ca782076&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca782076",
  null
  
)

export default component.exports